/* Shiro Drip — muro de reseñas: columnas estables + botón "ver más" */
(function () {
  function columnasSegunPantalla(wall) {
    var w = window.innerWidth;
    if (w >= 990) return parseInt(wall.dataset.colsDesktop, 10) || 4;
    if (w >= 750) return parseInt(wall.dataset.colsTablet, 10) || 3;
    return parseInt(wall.dataset.colsMobile, 10) || 2;
  }

  function montar(section) {
    var wall = section.querySelector('[data-reviews-wall]');
    if (!wall || wall.dataset.montado === 'true') return;
    wall.dataset.montado = 'true';

    var button = section.querySelector('[data-reviews-more]');
    // Orden del servidor: primero las que llevan foto, luego las de texto.
    var todas = Array.prototype.slice.call(wall.querySelectorAll('[data-review]'));
    if (!todas.length) return;

    var visibles = todas.filter(function (c) { return !c.hidden; }).length || todas.length;
    var tanda = button ? (parseInt(button.dataset.batch, 10) || 6) : 0;
    var columnas = [];
    var colocadas = 0;

    function crearColumnas(n) {
      wall.innerHTML = '';
      columnas = [];
      for (var i = 0; i < n; i++) {
        var col = document.createElement('div');
        col.className = 'sd-reviews__col';
        wall.appendChild(col);
        columnas.push(col);
      }
      wall.classList.add('is-columns');
    }

    function masCorta() {
      var mejor = columnas[0];
      for (var i = 1; i < columnas.length; i++) {
        if (columnas[i].offsetHeight < mejor.offsetHeight) mejor = columnas[i];
      }
      return mejor;
    }

    // Reparte de dos en dos (o de N en N) por orden, sin tocar lo ya colocado
    function colocar(desde, hasta) {
      for (var i = desde; i < hasta; i++) {
        todas[i].hidden = false;
        masCorta().appendChild(todas[i]);
      }
    }

    function repintar(n) {
      crearColumnas(n);
      colocar(0, colocadas);
    }

    colocadas = visibles;
    repintar(columnasSegunPantalla(wall));

    if (button) {
      button.addEventListener('click', function () {
        var hasta = Math.min(colocadas + tanda, todas.length);
        var primeraNueva = todas[colocadas];
        colocar(colocadas, hasta);
        colocadas = hasta;
        if (colocadas >= todas.length) button.hidden = true;
        if (primeraNueva) {
          primeraNueva.setAttribute('tabindex', '-1');
          primeraNueva.focus({ preventScroll: true });
        }
      });
    }

    // Al cambiar de tamaño solo se rehace si cambia el número de columnas
    var ultimas = columnasSegunPantalla(wall);
    var temporizador;
    window.addEventListener('resize', function () {
      clearTimeout(temporizador);
      temporizador = setTimeout(function () {
        var n = columnasSegunPantalla(wall);
        if (n !== ultimas) { ultimas = n; repintar(n); }
      }, 200);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.sd-reviews').forEach(montar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
